import { render } from "./WhatsappAction.vue?vue&type=template&id=abf1fd18&scoped=true"
import script from "./WhatsappAction.vue?vue&type=script&lang=js"
export * from "./WhatsappAction.vue?vue&type=script&lang=js"

import "./WhatsappAction.vue?vue&type=style&index=0&id=abf1fd18&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf1fd18"]])

export default __exports__